// Visibility Check™ JotForm assessment URL
// TODO: Replace this placeholder with the real Visibility Check JotForm URL
// when it's published. All "Start the Visibility Check™" buttons across
// /visibility-check and homepage CTA references read from this constant.
export const VISIBILITY_CHECK_URL =
  "https://form.jotform.com/PLACEHOLDER_VISIBILITY_CHECK";

export const openVisibilityCheck = () => {
  window.open(VISIBILITY_CHECK_URL, "_blank", "noopener,noreferrer");
};
